import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomProgressBar, {atomProgressBarSizes, atomProgressBarTypes} from '@s-ui/react-atom-progress-bar'
import Context from '@s-ui/react-context'

import {BASE_CLASS} from '../settings.js'

export function ProgressBar({breadcrumb, step, totalSteps}) {
  const {i18n} = useContext(Context)
  const percentage = Math.round((step / totalSteps) * 100)
  const stepLabel = i18n.t('COMMON.STEP_OF_TOTAL', {step, total: totalSteps})

  return (
    <div className={`${BASE_CLASS}-summary`}>
      {breadcrumb && <span>{`${stepLabel}: ${breadcrumb}`}</span>}
      <AtomProgressBar
        hideIndicator
        isBorderless
        isAnimatedOnChange
        percentage={percentage}
        size={atomProgressBarSizes.MEDIUM}
        type={atomProgressBarTypes.LINE}
      />
    </div>
  )
}

ProgressBar.displayName = 'StepperFlowProgressBar'
ProgressBar.propTypes = {
  breadcrumb: PropTypes.string,
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
}
